/* istanbul ignore file */
export * from './radio-list-item.component';
export type { RadioListItemValue } from './radio-list-item.component';
